module.exports = __webpack_public_path__ + "img/2025-7.c0f3ff42.jpg";